import React from 'react'

import {
  ROLE_COLORS, ROLE_LABELS
} from './config/constants'

class RoleIndicator extends React.Component {
  constructor (props) {
    super(props)

    this.state = {}
  }

  render () {
    return (
      <div className='role-indicator label label-primary' style={{backgroundColor: ROLE_COLORS[this.props.role], fontSize: this.props.size}}>
        {ROLE_LABELS[this.props.role]}
      </div>
    )
  }
}

RoleIndicator.defaultProps = {
  role: 1,
  size: 10
}

export default RoleIndicator



/** WEBPACK FOOTER **
 ** ./modules/shared/role_indicator.js
 **/